import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { BreakpointEnum } from "../../enums/pixel-breakpoints";

@Injectable({
    providedIn: 'root'
  })
export class DocumentEventsService {

    /**
     * Observable to check if the document has been clicked
     * Run's outside ngZone to avoid change detection performance issues
     */
    public documentClickEvent: Subject<Event> = new Subject<Event>();

    /**
     * Observable to check if the a keydown event has been triggered on the document
     * Run's outside ngZone to avoid change detection performance issues
     */
    public documentKeydownEvent: Subject<KeyboardEvent> = new Subject<KeyboardEvent>();

    /**
     * Observable to check if the window has been resized
     * It's advisable to use a debounceTime operator to avoid performance issues
     * Or use the resizeObserver API instead !!!
     */
    public windowResizeEvent: Subject<Event> = new Subject<Event>();

    /**
     * Observable to check if the current device is a mobile device (width < 640px)
     * Only updated when breakpoint threshold is crossed
     */
    public isMobile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public constructor() {
        this.windowResizeEvent.subscribe((event: any) => {
            if (this.isMobile.value != event.target.innerWidth <= BreakpointEnum.SM) {
                this.isMobile.next(event.target.innerWidth <= BreakpointEnum.SM);
            }
        });
        this.isMobile.next(window.innerWidth <= BreakpointEnum.SM);
    }

}